<template>
  <div id="func-53">
    <span v-if="!beneficiarioSelecionado" class="title align-title">{{titulo}}</span>
    <p class="subtitulo">{{subtitulo}}</p>
    <StepGrupoFamiliar
      :numero-contrato="$route.query.contrato"
      v-model="beneficiarioSelecionado"
      :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
      id-funcionalidade="53"
    >
      <StepFormulario :paciente="beneficiarioSelecionado" v-if="beneficiarioSelecionado"/>
    </StepGrupoFamiliar>
  </div>
</template>
<script>
import StepGrupoFamiliar from '@/views/53/components/StepGrupoFamiliar'
import { mapGetters, mapState } from 'vuex'
import StepFormulario from '@/views/53/Steps/StepFormulario'

export default {
  data () {
    return {
      beneficiarioSelecionado: null,
      form: {}
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    titulo () {
      return this.funcionalidade.parametros.textos.tituloTelaSelecaoContato
    },
    subtitulo () {
      return this.funcionalidade.parametros.textos.subtituloTelaSelecaoContato
    }
  },
  components: {
    StepFormulario,
    StepGrupoFamiliar
  }
}
</script>
<style lang="less">
</style>
